export const NOTES_LIMIT = 35

export enum NoteType {
  UserGenerated = 'userGenerated',
  BufferGenerated = 'bufferGenerated',
  AiGenerated = 'aiGenerated',
}
